import {
    Stack,
    Typography,
    FormControlLabel,
    Switch,
    Divider,
    Button,
} from "@mui/material";

export default function UserRolesSettings() {
    return (
        <>
            <Typography
                sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    mb: 0.5,
                }}
            >
                User Roles & Permissions
            </Typography>

            <Typography sx={{ color: "#777", mb: 4 }}>
                Manage staff access permissions
            </Typography>

            <Stack spacing={2}>
                <Typography fontWeight={700}>
                    Cashier Permissions
                </Typography>

                <FormControlLabel
                    control={<Switch />}
                    label="Can Edit Orders"
                />

                <FormControlLabel
                    control={<Switch />}
                    label="Can Delete Orders"
                />

                <FormControlLabel
                    control={<Switch />}
                    label="Can Print Receipts"
                />

                <Divider />

                <Typography fontWeight={700}>
                    Admin Permissions
                </Typography>

                <FormControlLabel
                    control={<Switch defaultChecked />}
                    label="Full Access"
                />

                <Button
                    variant="contained"
                    sx={{
                        width: "fit-content",
                        backgroundColor: "#111",
                        borderRadius: 3,
                        textTransform: "none",
                        mt: 2,
                    }}
                >
                    Save Changes
                </Button>
            </Stack>
        </>
    );
}